import React from 'react';
import { RowsPerPageSelector as Component, RowsPerPageSelectorProps } from '../../components/RowsPerPageSelector';
import { usePaginator } from '../../Paginator.provider';

type Props = RowsPerPageSelectorProps;

export const RowsPerPageSelector: React.VFC<Props> = (props) => {
  const { options } = usePaginator();
  return <Component {...options.rowsPerPageDropdown} {...props} />;
};

export type { Props as RowsPerPageSelectorProps };
